import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import QuanLyNghiService from "services/QuanLyNghiService";

export const ExportDonXinNghi = createAsyncThunk(
  "qlNghiSlice/ExportDonXinNghi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, searchData } = data;
      // const payload = cloneDeep(data);
      // delete payload.onSuccess;
      const response = await QuanLyNghiService.exportDonXinNghi(searchData);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const SearchBaoCaoXinNghi = createAsyncThunk(
  "qlNghiSlice/searchBaoCaoNghi",
  async (data, { rejectWithValue }) => {
    try {
      // const payload = cloneDeep(data);
      // delete payload.onSuccess;
      const response = await QuanLyNghiService.searchBaoCaoXinNghi(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const SearchDonXinNghi = createAsyncThunk(
  "qlNghiSlice/SearchDonXinNghi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await QuanLyNghiService.searchDonXinNghi(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const GetDonXinNghiDetail = createAsyncThunk(
  "qlNghiSlice/GetDonXinNghiDetail",
  async (id, { rejectWithValue }) => {
    try {
      const response = await QuanLyNghiService.donXinNghiDetail(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const UpSertDonXinNghi = createAsyncThunk(
  "qlNghiSlice/UpSertDonXinNghi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await QuanLyNghiService.upSertDonXinNghi(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const DeleteDonXinNghi = createAsyncThunk(
  "qlNghiSlice/DeleteDonXinNghi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response = await QuanLyNghiService.deleteDonXinNghi(id);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const UpdateEmployeeApproveDonXinNghi = createAsyncThunk(
  "qlNghiSlice/UpdateEmployeeApproveDonXinNghi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await QuanLyNghiService.employeeApprove(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const SearchNghiPhepNam = createAsyncThunk(
  "qlNghiSlice/SearchNghiPhepNam",
  async (data, { rejectWithValue }) => {
    try {
      const response = await QuanLyNghiService.searchNghiPhepNam(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const AddNewNghiPhepNam = createAsyncThunk(
  "qlNghiSlice/AddNewNghiPhepNam",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await QuanLyNghiService.addNewNghiPhepNam(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const UpdateNghiPhepNam = createAsyncThunk(
  "qlNghiSlice/UpdateNghiPhepNam",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await QuanLyNghiService.updateNghiPhepNam(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const UpdateNghiPhepNamByIds = createAsyncThunk(
  "qlNghiSlice/UpdateNghiPhepNamByIds",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await QuanLyNghiService.updateNghiPhepNamByIds(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const SearchDoXacNhanCong = createAsyncThunk(
  "qlNghiSlice/SearchDoXacNhanCong",
  async (data, { rejectWithValue }) => {
    try {
      const response = await QuanLyNghiService.searchDonXacNhanCong(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const GetDoXacNhanCongDetail = createAsyncThunk(
  "qlNghiSlice/GetDoXacNhanCongDetail",
  async (id, { rejectWithValue }) => {
    try {
      const response = await QuanLyNghiService.donXacNhanCongDetail(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);


export const UpSertDonXacNhanCong = createAsyncThunk(
  "qlNghiSlice/UpSertDonXacNhanCong",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await QuanLyNghiService.upSertDonXacNhanCong(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const DeleteDonXacNhanCong = createAsyncThunk(
  "qlNghiSlice/DeleteDonXacNhanCong",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response = await QuanLyNghiService.deleteDonXacNhanCong(id);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);


export const UpdateDonXacNhanCongVanBan = createAsyncThunk(
  "qlNghiSlice/UpdateDonXacNhanCongVanBan",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = { id: data.id, vanBan: data.vanBan };
      const response = await QuanLyNghiService.updateDonXacNhanCongVanBan(payload);
      if (response.data?.isOk && onSuccess) onSuccess();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const SearchThietLapLyDoXacNhanCong = createAsyncThunk(
  "qlNghiSlice/SearchThietLapLyDoXacNhanCong",
  async (data, { rejectWithValue }) => {
    try {
      const response = await QuanLyNghiService.searchThietLapLyDoCate(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const UpSertThietLapLyDoXacNhanCong = createAsyncThunk(
  "qlNghiSlice/UpSertThietLapLyDoXacNhanCong",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await QuanLyNghiService.upSertThietLapLyDoCate(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  list: [],
  detail: {},
  phepNamList: [],
};

export const qlNghiSlice = createSlice({
  name: "qlNghi",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    setHisInfo: (state, action) => {
      state.hisInfoList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(SearchDonXinNghi.pending, (state) => {
        state.loading = true;
      })
      .addCase(SearchDonXinNghi.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(SearchDonXinNghi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(GetDonXinNghiDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetDonXinNghiDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.detail = action.payload;
      })
      .addCase(GetDonXinNghiDetail.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(UpSertDonXinNghi.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpSertDonXinNghi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(UpSertDonXinNghi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(DeleteDonXinNghi.pending, (state) => {
        state.loading = true;
      })
      .addCase(DeleteDonXinNghi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(DeleteDonXinNghi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(SearchNghiPhepNam.pending, (state) => {
        state.loading = true;
      })
      .addCase(SearchNghiPhepNam.fulfilled, (state, action) => {
        state.loading = false;
        state.phepNamList = action.payload;
      })
      .addCase(SearchNghiPhepNam.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(AddNewNghiPhepNam.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddNewNghiPhepNam.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(AddNewNghiPhepNam.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(UpdateNghiPhepNam.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdateNghiPhepNam.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(UpdateNghiPhepNam.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(SearchDoXacNhanCong.pending, (state) => {
        state.loading = true;
      })
      .addCase(SearchDoXacNhanCong.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(SearchDoXacNhanCong.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(GetDoXacNhanCongDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetDoXacNhanCongDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.detail = action.payload;
      })
      .addCase(GetDoXacNhanCongDetail.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(UpSertDonXacNhanCong.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpSertDonXacNhanCong.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(UpSertDonXacNhanCong.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(DeleteDonXacNhanCong.pending, (state) => {
        state.loading = true;
      })
      .addCase(DeleteDonXacNhanCong.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(DeleteDonXacNhanCong.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(SearchThietLapLyDoXacNhanCong.pending, (state) => {
        state.loading = true;
      })
      .addCase(SearchThietLapLyDoXacNhanCong.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(SearchThietLapLyDoXacNhanCong.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(UpSertThietLapLyDoXacNhanCong.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpSertThietLapLyDoXacNhanCong.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(UpSertThietLapLyDoXacNhanCong.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(SearchBaoCaoXinNghi.pending, (state) => {
        state.loading = true;
      })
      .addCase(SearchBaoCaoXinNghi.fulfilled, (state, action) => {
        state.loading = false;
        state.listBaoCao = action.payload;
      })
      .addCase(SearchBaoCaoXinNghi.rejected, (state) => {
        state.loading = false;
      })

  },
});

export const { showLoading } = qlNghiSlice.actions;

export default qlNghiSlice.reducer;
